"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailShowMore = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
require("./styles.less");
function LeftRailShowMore(props) {
    return (React.createElement("div", { className: "m-show-more " + props.className, onClick: props.onClick }, "Show more"));
}
exports.LeftRailShowMore = LeftRailShowMore;
